import ReactTooltip from "react-tooltip";
import styled from "styled-components";
import { Images } from "./assets";

const ToolTip = styled.div`
  width: ${(props) => props.isCampaignForm && "280px"};
  min-width: 280px;
  background: #e6e6e6;
  border: 1px solid #b3b3b3;
  opacity: 1 !important;
  display: flex;
  justify-content: space-between;
`;

const ToolTipIcon = styled.img`
  height: 100%;
  width: auto;
  margin-left: inherit;
  margin-bottom: inherit;
`;

const TooltipReact = ({
  id = 0,
  toolTip,
  content = null,
  align = "right",
  customClassName = "custom-tooltip",
  tooltipStyle = {},
  defaultTag = "span",
  tooltipClass = "card-tooltip",
  toolTipContainerClass = "tooltip-container",
}) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const TooltipTag = defaultTag;

  return (
    <TooltipTag style={{ ...tooltipStyle }} className={customClassName}>
      {content ? (
        <div
          style={{
            // maxHeight: '2.4em',
            wordWrap: "break-word",
            overflow: "hidden",
            textOverflow: "ellipsis",
            // border: '1px solid grey',
            fontSize: tooltipStyle.fontSize || "12px",
          }}
          data-for={`card-tooltip_${id}`}
          data-tip
          className={"ellipsisFieldValue"}
        >
          {content}
        </div>
      ) : (
        <ToolTipIcon
          style={{ width: 20 }}
          src={Images.Exclamation}
          data-tip
          data-for={`card-tooltip_${id}`}
          alt={"info"}
        />
      )}

      <ReactTooltip
        id={`card-tooltip_${id}`}
        className={tooltipClass}
        event={isMobile ? "click" : undefined}
        globalEventOff={isMobile ? "touchstart" : undefined}
        delayHide={isMobile ? undefined : id === 0 ? 1000 : 100}
        type="light"
        place={align}
        effect="solid"
        {...(isMobile && {
          dataEvent: "dblclick",
        })}
      >
        <ToolTip className={toolTipContainerClass} isCampaignForm={id === 0}>
          {toolTip}
        </ToolTip>
      </ReactTooltip>
    </TooltipTag>
  );
};

export default TooltipReact;
